import { useSyncExternalStore } from 'react';

/** Subscribes to a CSS media query. Used to pick table versus card layouts without rendering both. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', notify);
      return () => mql.removeEventListener('change', notify);
    },
    () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false),
    () => false,
  );
}

/** Tailwind's `sm` breakpoint: tables from 640 px, cards below. */
export const useIsWide = (): boolean => useMediaQuery('(min-width: 640px)');
